import React from 'react';
import { Link } from 'react-router-dom';
import { Price } from '../../../../../UI/Price/Price';
import { Quantity } from '../../../../Shared/Content/ProductDetail/ProductQuantity/ProductQuantity';
import ProductDetailForm from '../../../../Shared/Content/ProductDetail/ProductDetailForm/ProductDetailForm';
import ProductDetailSwatches from '../../../../Shared/Content/ProductDetail/ProductDetailSwatches/ProductDetailSwatches';
import ProductDetailAttribute from '../../../../Shared/Content/ProductDetail/ProductDetailAttribute/ProductDetailAttribute';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { Title } from '../../../../Shared/Content/ProductDetail/ProductTitle/ProductTitle';
import { ItemNumber } from '../../../../Shared/Content/ProductDetail/ProductItemNumber/ProductItemNumber';
import { ProductDescription } from '../../../../Shared/Content/ProductDetail/ProductDescription/ProductDescription';
import { BrandDescription } from '../../../../Shared/Content/ProductDetail/BrandDescription/BrandDescription';
import { ProductCollection } from '../../../../Shared/Content/ProductDetail/ProductCollection/ProductCollection';
import { WishListMessage } from '../../../../Shared/Content/ProductDetail/WishListMessage/WishListMessage';
import { ProductExtraVerbiage } from '../../../../Shared/Content/ProductDetail/ProductExtraVerbiage/ProductExtraVerbiage';
import { AddToBrandFavorites } from '../../../../Shared/Content/ProductDetail/AddToBrandFavorites/AddToBrandFavorites';
import AfterPayMessaging from '../../../../Shared/Content/ProductDetail/AfterPayMessaging/AfterPayMessaging';
import InvalidCombo from '../../../../Shared/Content/ProductDetail/InvalidCombo/InvalidCombo';
import { PhotoSwipeZoom } from '../PhotoSwipeZoom/PhotoSwipeZoom';
import ProductMisc from '../../../../Shared/Content/ProductDetail/ProductMisc/ProductMisc';
import { ShowImboxModal } from '../../../../Shared/Content/Imbox/ShowImboxModal';

export class OutfitComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceWidth: 770,
      isOpen: false,
      options: {
        showHideOpacity: true,
        allowPanToNext: true,
        maxSpreadZoom: 3,
        closeOnVerticalDrag: true,
        focus: true,
      },
    };

    this.zoomIndex = 0;
  }

  openPhotoSwipe = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: true,
      options: {
        index: this.zoomIndex,
        closeOnScroll: false,
      },
    });
  };

  updateZoomIndex = (i) => {
    this.zoomIndex = i;
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  liveChatOnClickBeauty() {
    insideAPI.post('api/visitor/set_department', { department: 'Video' });
    window.openChatButtonClick();
  }

  render() {
    const contentData = this.props.contentData,
      brandName = contentData.brandNameForTitle,
      productTitle = contentData.productName || '',
      brandUrl = contentData.brandUrl;
    return (
      <>
        <section className='outfitItem__wrapper'>
          <ProductDetailForm
            currentAttributeState={this.props.currentAttributeState}
            passedFunctions={this.props.passedFunctions}
            contentData={this.props.contentData}
          >
            <div className='row'>
              <div className='col-5'>
                {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                  <>
                    <PhotoSwipeZoom
                      isOpen={this.state.isOpen}
                      options={this.state.options}
                      handleClose={this.handleClose}
                      passedFunctions={this.props.passedFunctions}
                      contentData={this.props.contentData}
                      selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                      updateZoomIndex={this.updateZoomIndex}
                    />
                    <MainImage
                      contentData={this.props.contentData}
                      passedAppFunctions={this.props.passedAppFunctions}
                      selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                      openPhotoSwipe={this.openPhotoSwipe}
                    />
                  </>
                ) : (
                  <MainImage
                    contentData={this.props.contentData}
                    passedAppFunctions={this.props.passedAppFunctions}
                    selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  />
                )}
                {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                  <span className='componentTapToZoom'>Tap image to zoom</span>
                ) : (
                  ''
                )}
                {this.props.contentData.pricing.offerPriceMax != '' &&
                (this.props.contentData.isInternational == 'Y' || !this.props.passedAppFunctions.isInternational()) ? (
                  <React.Fragment>
                    {this.props.contentData.productContainsRegPricedMerch == 'true' &&
                    this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                      ''
                    ) : (
                      <div className='row'>
                        <div className='col-sm-12 shopperActions'>
                          <div>
                            <div className='addToBagContainer'>
                              <InvalidCombo
                                currentAttributeState={this.props.currentAttributeState}
                                passedFunctions={this.props.passedFunctions}
                                passedAppFunctions={this.props.passedAppFunctions}
                              />
                              <button
                                className='btn btn-primary btn-block'
                                data-toggle='modal'
                                type='button'
                                role='button'
                                id='add-to-bag'
                                onClick={this.props.passedFunctions.checkForErrors}
                              >
                                Add To Bag
                              </button>
                            </div>
                            {this.props.contentData.superCat == 'Beauty' ? (
                              <button
                                className='btn btn-secondary btn-block beauty-chat'
                                role='button'
                                type='button'
                                onKeyPress={this.liveChatOnClickBeauty}
                                onClick={this.liveChatOnClickBeauty}
                                manual_cm_sp='video+chat-_-beauty-_-product'
                              >
                                <span className='sr-only'>Opens a simulated dialog</span>
                                Chat with a Beauty Expert
                              </button>
                            ) : (
                              ''
                            )}
                            <WishListMessage
                              passedFunctions={this.props.passedFunctions}
                              passedAppFunctions={this.props.passedAppFunctions}
                            />
                            {!this.props.passedAppFunctions.isInternational() ? (
                              <button
                                className='btn btn-block btn-tertiary'
                                role='button'
                                type='button'
                                id='add-to-wishlist'
                                onClick={this.props.passedFunctions.checkForErrorsWishlist}
                              >
                                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.58 12.44'>
                                  <title>heart</title>
                                  <g data-name='Layer 2'>
                                    <g data-name='Layer 1'>
                                      <path
                                        className='cls-1'
                                        d='M7.79,12.44a.54.54,0,0,1-.32-.11L1.66,7.46l0,0A4.78,4.78,0,0,1,0,4.14,4.15,4.15,0,0,1,4.14,0,4.13,4.13,0,0,1,7.82,2.14,4.19,4.19,0,1,1,14.3,7.33l-6.19,5A.5.5,0,0,1,7.79,12.44ZM2.32,6.71,7.8,11.29l5.84-4.71a3.15,3.15,0,0,0-2.21-5.4,3,3,0,0,0-3.08,2.4.51.51,0,0,1-.07.17A.64.64,0,0,1,7.83,4a.5.5,0,0,1-.44-.18,1.3,1.3,0,0,1-.14-.29A3,3,0,0,0,4.14,1,3.15,3.15,0,0,0,1,4.14,3.66,3.66,0,0,0,2.32,6.71Z'
                                      />
                                    </g>
                                  </g>
                                </svg>
                                Add To Wish List
                              </button>
                            ) : (
                              ''
                            )}
                          </div>
                          <div>
                            {!this.props.passedAppFunctions.isInternational() ? (
                              <button
                                className='btn btn-block btn-tertiary'
                                role='button'
                                type='button'
                                id='add-to-registry'
                                onClick={this.props.passedFunctions.checkForErrorsRegistry}
                              >
                                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50.42 49.84'>
                                  <title>gift</title>
                                  <g data-name='Layer 2'>
                                    <g data-name='Layer 1'>
                                      <path d='M48,9.79H39.64a5.33,5.33,0,0,0-1-9.43,5.3,5.3,0,0,0-4.09.1c-2.16,1-8,7.3-9.37,8.82C23.8,7.76,18,1.42,15.81.46a5.33,5.33,0,0,0-5.1,9.33H2.45A2.45,2.45,0,0,0,0,12.24v4.39a2.45,2.45,0,0,0,2.45,2.45H3a3.46,3.46,0,0,0-.53,1.84V46.35a3.5,3.5,0,0,0,3.49,3.49H44.41a3.5,3.5,0,0,0,3.49-3.49V20.92a3.46,3.46,0,0,0-.53-1.84H48a2.45,2.45,0,0,0,2.45-2.45V12.24A2.45,2.45,0,0,0,48,9.79ZM35.36,2.3A3.32,3.32,0,0,1,38,8.39c-1.2.53-6.12.76-10.05.81C30.68,6.32,34.16,2.83,35.36,2.3ZM10.61,4A3.33,3.33,0,0,1,15,2.3c1.2.53,4.68,4,7.36,6.89-3.93,0-8.85-.28-10.05-.81h0A3.33,3.33,0,0,1,10.61,4ZM2,16.63V12.24a.43.43,0,0,1,.43-.43H24.2v5.26H2.45A.43.43,0,0,1,2,16.63ZM4.47,46.35V20.92a1.48,1.48,0,0,1,1.48-1.48H24.2V47.82H5.94A1.48,1.48,0,0,1,4.47,46.35Zm41.42,0a1.48,1.48,0,0,1-1.48,1.48H26.22V19.44H44.41a1.48,1.48,0,0,1,1.48,1.48Zm2.52-29.71a.43.43,0,0,1-.43.43H26.22V11.81H48a.43.43,0,0,1,.43.43Z' />
                                    </g>
                                  </g>
                                </svg>
                                Add To Registry
                              </button>
                            ) : (
                              ''
                            )}
                          </div>
                          <div>
                            <AddToBrandFavorites
                              passedAppFunctions={this.props.passedAppFunctions}
                              contentData={this.props.contentData}
                              passedFunctions={this.props.passedFunctions}
                              parentPersonalization={this.props.parentPersonalization}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ) : (
                  ''
                )}
              </div>
              <div className='col-7'>
                <Title
                  contentData={this.props.contentData}
                  isBundle={this.props.parentProductLayout == 'BundleDisplay'}
                  passedAppFunctions={this.props.passedAppFunctions}
                />
                <Price pricing={this.props.contentData.pricing} />
                {/* MISC - DILLARD'S CARD INFO, PAYPAL & AFTERPAY MSG */}
                {/* <ProductMisc contentData={this.props.contentData} passedFunctions={this.props.passedFunctions} passedAppFunctions={this.props.passedAppFunctions} showHorizonatalEspot={false} isBundle={this.props.parentProductLayout == 'BundleDisplay'} /> */}
                <ProductDescription
                  contentData={this.props.contentData}
                  passedAppFunctions={this.props.passedAppFunctions}
                />
                <BrandDescription
                  open={false}
                  contentData={this.props.contentData}
                  passedAppFunctions={this.props.passedAppFunctions}
                />
                {this.props.contentData.isInternational == 'Y' || !this.props.passedAppFunctions.isInternational() ? (
                  <>
                    {this.props.contentData.salePage == 'true' &&
                    this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                      <>
                        <span className='d-block regularPriceOptionsText'>
                          This item is no longer available in Sale and Clearance.
                        </span>
                        <Link
                          to={`/p/${this.props.contentData.productNameForURL}/${this.props.contentData.productId}`}
                          className='regularPriceOptions'
                        >
                          See Regular Price Options
                        </Link>
                      </>
                    ) : (
                      <>
                        <ProductDetailAttribute
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                          updateAttribute={this.props.passedFunctions.updateAttribute}
                          updateAttrState={this.props.passedFunctions.updateAttrState}
                          currentAttributeState={this.props.currentAttributeState}
                          contentData={this.props.contentData}
                          isBundle={true}
                        />
                        <Quantity
                          passedAppFunctions={this.props.passedAppFunctions}
                          quantityErrored={this.props.passedFunctions.parentState.quantityErrored}
                          forceQuantity={this.props.passedFunctions.forceQuantity}
                          updateQuantity={this.props.passedFunctions.updateQuantity}
                          quantity={this.props.passedFunctions.parentState.quantity}
                          contentData={this.props.contentData}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <div id='error-message' className='alert alert-danger' role='alert'>
                    This item is not available for international purchase.
                  </div>
                )}
              </div>
            </div>
            {this.props.contentData.pricing.offerPriceMax != '' ? (
              <ProductCollection
                passedAppFunctions={this.props.passedAppFunctions}
                contentData={this.props.contentData}
                selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                attributeState={this.props.passedFunctions.parentState.attributeState}
                slidesToShow={3}
                passedFunctions={this.props.passedFunctions}
              />
            ) : (
              ''
            )}
          </ProductDetailForm>
          <ShowImboxModal passedFunctions={this.props.passedFunctions} />
        </section>
      </>
    );
  }
}

export default OutfitComponent;
